/** Общи текстове за няколко страници. Текстът на всяка страница е в отделен файл. */
export default {
  language: "Език",
  nav: {
    howItWorks: "Как работи",
    demo: "Демо",
    pricing: "Цени",
    faq: "Въпроси",
    contact: "Контакти",
    generate: "Генериране",
    generateNow: "Генерирай сега",
    profile: "Профил",
    signIn: "Вход",
    signOut: "Изход",
    toggleMenu: "Отвори менюто",
  },
  actions: {
    backToHome: "Към началото",
    backToPricing: "Към цените",
    tryAgain: "Опитайте отново",
    loading: "Зареждане…",
    pleaseWait: "Моля, изчакайте…",
    save: "Запази",
    cancel: "Отказ",
    close: "Затвори",
    copy: "Копирай",
    copied: "Копирано",
    download: "Изтегли",
  },
  legal: {
    termsOfUse: "Общи условия",
    privacyPolicy: "Политика за поверителност",
    refundPolicy: "Политика за възстановяване на суми",
    deliveryPolicy: "Политика за доставка",
    cookiePolicy: "Политика за бисквитките",
  },
  cookies: {
    banner: {
      title: "Ценим вашата поверителност",
      text: "Използваме строго необходими бисквитки, за да поддържаме входа ви в профила и за процеса на плащане. С ваше съгласие запомняме и избрания език и пазим последните ви генерирания в този браузър. Не използваме бисквитки за анализ или реклама. Можете да промените избора си по всяко време от „Настройки за бисквитките“ в долния колонтитул на сайта.",
    },
    acceptAll: "Приемам всички",
    rejectOptional: "Отказвам незадължителните",
    customize: "Персонализиране",
    save: "Запази избора ми",
    settingsTitle: "Настройки за бисквитките",
    settingsIntro: "Изберете кои незадължителни бисквитки можем да използваме. Строго необходимите бисквитки са винаги включени, защото сайтът не може да работи без тях. Изключването на категория изтрива съхраненото от нея.",
    alwaysOn: "Винаги включени",
    footerLink: "Настройки за бисквитките",
    categories: {
      necessary: {
        name: "Строго необходими",
        description: "Поддържат входа ви в профила, пазят данните от поръчката, докато плащате в банката, и запомнят избора ви за бисквитките.",
      },
      preferences: {
        name: "Предпочитания",
        description: "Запомнят избрания от вас език, за да се отваря сайтът на него следващия път.",
      },
      functional: {
        name: "Функционалност",
        description: "Пазят последните ви изображения и видеа на страница „Генериране“ и след като я затворите.",
      },
    },
  },
  merchant: {
    title: "Търговец",
    company: "Фирма",
    tradingAs: "търговско наименование {{name}}",
    uic: "ЕИК",
    uicValue: "ЕИК {{uic}} · регистрирана и установена в България (ЕС)",
    address: "Адрес",
    website: "Уебсайт и контакт",
  },
  contentRules:
    "Всичко тук е генерирано с изкуствен интелект. Не се допуска съдържание със сексуален характер, насилие, омраза или незаконни действия, нито реалистични изображения на реални хора без тяхното съгласие – промптовете се проверяват автоматично. Вижте <terms>правилата за допустима употреба</terms>.",
  prices: {
    note: "Всички цени са в евро (EUR) и включват всички приложими данъци. Без скрити такси и без минимална сума на поръчката.",
  },
  banks: {
    dsk: "Банка ДСК",
    postbank: "Пощенска банка",
  },
  errors: {
    generic: "Нещо се обърка. Моля, опитайте отново.",
    unexpected: "Неочаквана грешка.",
  },
};
